import Phaser, { Scene } from 'phaser';
import EDC from '@/components/games/shared/globals';
import CursorManager from '@/components/games/shared/cursor-manager';
import router from '@/router/index';
import store from '@/store/index';

class SiteMenuMainScene extends Scene {
  activeAccount = store.getters['children/activeChildProfile'];
  avatarFrame = null;
  avatar = null;
  avatarContainer = null;
  fullMenuWidth = 0;
  fullMenuHeight = 0;
  homeLinkContainer = null;
  aboutLinkContainer = null;
  canAccessSideMenu = true;
  restartLinkContainer = null;
  linkFrame = null;
  linkShiftY = 165;
  linkContainerHeight = 80;
  cornerFrameWidth = 40;
  soundIcon = null;
  iconRadius = 90;
  nickname = '';
  nicknameContainer = null;
  linkAnimationDuration = 800;
  linkContainers = [];
  isMenuOpen = false;
  cursorManager = null;
  avatarScaleTween = null;
  assignmentContainer = null;
  assignments = store.getters['assignments/assignments'];
  currentAssignment = store.getters['gameConfig/getCurrentAssignment'];
  assignmentLinks = [];
  exitBtn = null;
  assignmentsCounter = null;
  showStatusAssignments = false;
  containerWrapper = null;

  get initialMenuWidth() {
    return 120;
  }

  get initialMenuHeight() {
    return this.assignments.length ? 360 : 210;
  }

  get maxMenuWidth() {
    const width = window.innerWidth / this.game.config.zoom;
    if (this.scale.isLandscape) {
      return width / 2;
    }
    return width;
  }

  get maxMenuHeight() {
    return window.innerHeight / this.game.config.zoom;
  }

  get menuWrapWidth() {
    return 60;
  }

  get menuWrapHeight() {
    return 35;
  }

  create() {
    this.cursorManager = new CursorManager(this.game.canvas);
    this.cursorManager.resetCursor();

    this.containerWrapper = this.add.rectangle(this.initialMenuWidth, this.initialMenuHeight, 1000, 9000, 0, 0).setInteractive();
    this.containerWrapper.on('pointerdown', () => {
      this.hideAssignments();
    });

    this.avatarFrame = this.add
      .sprite(0, 0, 'site-menu-avatar-frame')
      .setDisplaySize(this.initialMenuWidth - 10, this.initialMenuWidth - 10);
    this.avatar = this.add.sprite(0, 0, 'site-menu-account-image').setScale(0.157);

    this.nicknameContainer = this.addName();

    this.avatarContainer = this.add.container(this.game.config.width / 2, 60,
      [this.avatarFrame, this.avatar]);
    this.avatarContainer.setSize(this.avatarFrame.displayWidth, this.avatarFrame.displayHeight);
    const avatarContainerHitArea = new Phaser.Geom.Circle(0, 0, 110);
    this.avatarContainer.setInteractive(avatarContainerHitArea, Phaser.Geom.Circle.Contains);
    this.cursorManager.setDefaultDraggableEvents(this.avatarContainer);
    const animate = () => {
      this.avatarScaleTween = this.tweens.add({
        targets: this.avatarContainer,
        scaleX: 1.07,
        scaleY: 1.07,
        ease: 'Sine.easeInOut',
        duration: 500,
        repeat: 2,
        yoyo: true,
        onComplete: () => {
          this.time.addEvent({
            delay: 5000,
            callback: () => animate(),
          });
        },
      });
    };

    animate();
    this.exitBtn = this.add.sprite(this.fullMenuWidth - 40, 275, 'site-menu-exit-btn').setDisplaySize(40, 40);

    this.createAssignmentCounter();
    this.createAssignmentWidget();
    this.scale.resize(this.initialMenuWidth, this.initialMenuHeight);

    window.document.addEventListener('click', (e) => {
      const isMenu = e.target.closest('#site-menu');

      if (!isMenu && this.showStatusAssignments) {
        this.hideAssignments();
      }
    });

    this.assignments.forEach((assignment, i) => {
      const link = this.createAssignmentLink(assignment, i);
      link.on('pointerdown', () => {
        this.goToAssignment(assignment._id);
      });
    });

    this.assignmentContainer.on('pointerdown', () => {
      if (this.showStatusAssignments) return;
      this.showAssignments();
    });

    this.exitBtn.setInteractive();
    this.exitBtn.on('pointerdown', () => {
      this.hideAssignments();
    });

    this.aboutLinkContainer = this.createLink('site-menu-about-link', 'site-menu-about-icon');
    this.aboutLinkContainer.on('pointerover', () => {
      this.highlightLink(this.aboutLinkContainer);
    });
    this.aboutLinkContainer.on('pointerout', () => {
      this.removeLinkHighlight(this.aboutLinkContainer);
    });
    this.aboutLinkContainer.on('pointerdown', () => {
      const gameId = router.currentRoute.params.id;
      if (gameId) {
        const cfg = store.getters['games/getGameById'](gameId).sets[0].config;
        this.createPopUp(cfg.description);
      } else {
        this.hideMenuLinks();
      }
    });

    this.mainMenuLinkContainer = this.createLink('site-menu-mainmenu-link', 'site-menu-home-icon');
    this.mainMenuLinkContainer.on('pointerover', () => {
      this.highlightLink(this.mainMenuLinkContainer);
    });
    this.mainMenuLinkContainer.on('pointerout', () => {
      this.removeLinkHighlight(this.mainMenuLinkContainer);
    });
    this.mainMenuLinkContainer.on('pointerdown', () => {
      router.push({ name: 'main-menu' });
      this.hideMenuLinks();
      // const gameId = router.currentRoute.params.id;
      // if (gameId) {
      //   const cfg = store.getters['games/getGameById'](gameId).sets[0].config;
      //   this.createPopUp(cfg.description);
      // } else {
      //   this.hideMenuLinks();
      // }
    });

    this.restartLinkContainer = this.createLink('site-menu-restart-link', 'site-menu-restart-icon');
    this.restartLinkContainer.on('pointerover', () => {
      this.highlightLink(this.restartLinkContainer);
    });
    this.restartLinkContainer.on('pointerout', () => {
      this.removeLinkHighlight(this.restartLinkContainer);
    });
    this.restartLinkContainer.on('pointerdown', () => {
      const gameId = router.currentRoute.params.id;
      if (gameId) {
        window.activeGame.destroy(true);
        window.activeGame.canvas.remove();
        window.activeGame = window.kickOff();
      }
      this.hideMenuLinks();
    });

    this.homeLinkContainer = this.createLink('site-menu-home-link', 'site-menu-home-icon');
    this.homeLinkContainer.on('pointerover', () => {
      this.highlightLink(this.homeLinkContainer);
    });
    this.homeLinkContainer.on('pointerout', () => {
      this.removeLinkHighlight(this.homeLinkContainer);
    });
    this.homeLinkContainer.on('pointerdown', () => {
      const game = window.activeGame;
      if (game) {
        game.destroy();
        game.canvas.remove();
        window.activeGame = null;
      }
      router.push({ name: 'games' });
      this.hideMenuLinks();
    });

    this.soundIcon = this.add.sprite(0, 0, 'site-menu-sound-on-icon').setDisplaySize(this.iconRadius, this.iconRadius);
    this.soundIcon.setPosition(this.avatarContainer.x, this.avatarContainer.y + 100);
    this.soundIcon.setInteractive();
    this.cursorManager.setDefaultDraggableEvents(this.soundIcon);
    this.soundIcon.on('pointerdown', () => {
      this.handleSound();
    });

    this.setInitialPositions();

    this.avatarContainer.on('pointerdown', () => {
      if (!this.canAccessSideMenu) return;
      this.canAccessSideMenu = false;
      if (this.isMenuOpen) {
        this.hideMenuLinks();
      } else {
        this.showMenuLinks();
      }
    });

    store.watch((state) => {
      this.currentAssignment = state.gameConfig.currentAssignment;
      this.updateSelectedAssignments();
    });
  }

  updateSelectedAssignments() {
    this.assignments.forEach((assignment, index) => {
      const graphics = this.assignmentLinks[index].first;
      // eslint-disable-next-line no-underscore-dangle
      const isCurrent = assignment._id === this.currentAssignment._id;

      graphics.fillStyle(0xffffff, 1);
      graphics.fillRoundedRect(0, 0, 340, 36, 18);
      // eslint-disable-next-line no-unused-expressions
      isCurrent ? graphics.lineStyle(3, 0xff0000, 3) : graphics.lineStyle(1, 0x3dd1ff, 1);
      graphics.strokeRoundedRect(2, 2, 340 - 4, 36 - 4, 16);
      graphics.fillStyle(0xededed, 1);
      graphics.fillRoundedRect(3, 3, 40, 36 - 6, {
        tl: 16, tr: 0, bl: 16, br: 0,
      });
    });
  }

  // create popUp description after pressing about
  createPopUp(description) {
    const gameWidth = 900;
    const gameHeight = 650;
    this.scale.resize(gameWidth, gameHeight);
    this.fullMenuWidth += gameWidth - this.fullMenuWidth;
    this.adjustMenuLinkPosition();
    const container = this.add.container(450, 0);
    container.setSize(450, 650);
    const background = this.add.graphics();
    const button = this.add.graphics();
    const submit = this.add.text(0, 0, 'Ok', { font: '54px font009' });
    const text = this.make.text({
      x: 30,
      y: 10,
      text: description,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: 'font009',
        fontSize: '54px',
        wordWrap: { width: '450' },
        lineSpacing: 10,
        align: 'center',
      },
    });
    background.lineStyle(5, 0xff0000, 1);
    background.fillStyle(0x000000, 0.6);
    background.fillRoundedRect(0, 0, 450, text.height + 15, 30);
    background.strokeRoundedRect(0, 0, 450, text.height + 15, 30);
    button.lineStyle(3, 0xff0000, 1);
    button.fillStyle(0xffffff, 8);
    button.fillRoundedRect(175, text.height + 15, 100, 60, 5);
    button.strokeRoundedRect(175, text.height + 15, 100, 60, 5);
    submit.setPosition(175 + 10, text.height + 25);
    container.add(background);
    container.add(text);
    container.add(button);
    container.add(submit);
    const rect = new Phaser.Geom.Rectangle(container.width / 2 + 175,
      text.height + 15 + container.height / 2, 100, 60);
    container.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
    container.on('pointerdown', () => {
      this.tweens.add({
        targets: container,
        scaleX: 0,
        scaleY: 0,
        ease: 'Linear',
        duration: 200,
        onComplete: () => container.destroy(),
      });
      this.avatarContainer.setInteractive();
      this.isMenuOpen = false;
    });
    // tween to pop up window
    container.setScale(0.1, 0.1);
    this.tweens.add({
      targets: container,
      scaleX: 1,
      scaleY: 1,
      ease: 'Elastic.Out',
      duration: 500,
    });

    container.on('pointerdown', () => {
      this.showAssignments();
    });
  }

  adjustMenuLinkPosition() {
    this.avatarContainer.setPosition(this.fullMenuWidth - 60, 60);
    this.soundIcon.x = this.fullMenuWidth - 60;
    this.slideSoundIcon(this.soundIcon, this.avatarContainer.y + 100);

    this.nicknameContainer.x = this.fullMenuWidth - this.nicknameContainer.width - 20;
    this.aboutLinkContainer.x = this.fullMenuWidth - this.aboutLinkContainer.width;
    this.mainMenuLinkContainer.x = this.fullMenuWidth - this.mainMenuLinkContainer.width;
    this.restartLinkContainer.x = this.fullMenuWidth - this.restartLinkContainer.width;
    this.homeLinkContainer.x = this.fullMenuWidth - this.homeLinkContainer.width;

    this.slideLink(this.nicknameContainer, this.fullMenuWidth);
    this.slideLink(this.aboutLinkContainer, this.fullMenuWidth + this.aboutLinkContainer.width);
    this.slideLink(this.mainMenuLinkContainer, this.fullMenuWidth + this.mainMenuLinkContainer.width);

    this.slideLink(this.restartLinkContainer, this.fullMenuWidth + this.restartLinkContainer.width);
    this.slideLink(this.homeLinkContainer, this.fullMenuWidth + this.homeLinkContainer.width);
    this.avatarContainer.disableInteractive();
  }

  /**
   * Create link container
   * @param linkName
   * @param linkIconName
   * @returns {*}
   */
  createLink(linkName, linkIconName) {
    const container = this.add.container(0, 0);
    let containerWidth = 0;

    this.linkFrame = { width: 20 };

    const spriteScale = linkName === 'site-menu-mainmenu-link' ? 0.6 : 0.4;
    const link = this.add.sprite(0, 0, linkName).setScale(spriteScale);
    const icon = this.add.sprite(0, 0, linkIconName).setDisplaySize(this.iconRadius, this.iconRadius);
    const numberOfFrames = Math.ceil((link.displayWidth + icon.displayWidth) / this.linkFrame.width);
    const linkBackground = [];

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < numberOfFrames; i++) {
      let posX = this.linkFrame.width * i - 10;
      let elem = null;

      if (i === 0) {
        posX = this.fullMenuWidth - (this.linkFrame.width * numberOfFrames + this.cornerFrameWidth);
        elem = this.add
          .sprite(-10, 0, 'site-menu-link-frame-left')
          .setDisplaySize(this.cornerFrameWidth, this.linkContainerHeight - 12);
      } else if (i === numberOfFrames - 1) {
        elem = this.add
          .sprite(posX, 0, 'site-menu-link-frame-right')
          .setDisplaySize(this.cornerFrameWidth, this.linkContainerHeight - 12);
      } else {
        elem = this.add
          .sprite(posX, 0, 'site-menu-link-frame')
          .setDisplaySize(this.linkFrame.width, this.linkContainerHeight - 12);
      }
      linkBackground.push(elem);
    }

    containerWidth = linkBackground.reduce((sum, currentElem) => sum + currentElem.displayWidth, 0);
    container.add(linkBackground);
    container.add(link);
    container.add(icon);
    container.setSize(containerWidth, this.linkContainerHeight);

    icon.setPosition(containerWidth - 40, -5);
    link.setPosition(containerWidth / 2 - 20, 0);

    this.linkContainers.push(container);

    return container;
  }

  /**
   * Set initial positions for menu links and name frame
   */
  setInitialPositions() {
    this.fullMenuWidth = this.getFullMenuWidth();
    this.fullMenuHeight = this.getFullMenuHeight();

    this.nicknameContainer.setPosition(this.fullMenuWidth + this.aboutLinkContainer.width, 60);

    this.aboutLinkContainer.setPosition(this.fullMenuWidth + this.aboutLinkContainer.width, this.linkShiftY);
    const aboutLinkHitArea = new Phaser.Geom.Rectangle(
      this.aboutLinkContainer.width / 2,
      0,
      this.aboutLinkContainer.width,
      this.linkContainerHeight,
    );
    this.aboutLinkContainer.setInteractive(aboutLinkHitArea, Phaser.Geom.Rectangle.Contains);
    this.cursorManager.setDefaultDraggableEvents(this.aboutLinkContainer);

    this.mainMenuLinkContainer.setPosition(this.fullMenuWidth + this.mainMenuLinkContainer.width, this.linkShiftY);
    const mainMenuLinkHitArea = new Phaser.Geom.Rectangle(
      this.mainMenuLinkContainer.width / 2,
      0,
      this.mainMenuLinkContainer.width,
      this.linkContainerHeight,
    );
    this.mainMenuLinkContainer.setInteractive(mainMenuLinkHitArea, Phaser.Geom.Rectangle.Contains);
    this.cursorManager.setDefaultDraggableEvents(this.mainMenuLinkContainer);

    const restartLinkY = this.linkShiftY + this.linkContainerHeight + 10;
    this.restartLinkContainer.setPosition(this.fullMenuWidth + this.restartLinkContainer.width, restartLinkY);
    const restartLinkHitArea = new Phaser.Geom.Rectangle(
      this.restartLinkContainer.width / 2,
      0,
      this.restartLinkContainer.width,
      this.linkContainerHeight,
    );
    this.restartLinkContainer.setInteractive(restartLinkHitArea, Phaser.Geom.Rectangle.Contains);
    this.cursorManager.setDefaultDraggableEvents(this.restartLinkContainer);

    const homeLinkY = this.linkShiftY + this.linkContainerHeight * 2 + 20;
    this.homeLinkContainer.setPosition(this.fullMenuWidth + this.homeLinkContainer.width, homeLinkY);
    const homeLinkHitArea = new Phaser.Geom.Rectangle(
      this.homeLinkContainer.width / 2,
      0,
      this.homeLinkContainer.width,
      this.linkContainerHeight,
    );
    this.homeLinkContainer.setInteractive(homeLinkHitArea, Phaser.Geom.Rectangle.Contains);
    this.cursorManager.setDefaultDraggableEvents(this.homeLinkContainer);
  }

  /**
   * Get full width for expanded menu
   * @returns {*}
   */
  getFullMenuWidth() {
    const maxLinkWidth = this.linkContainers.reduce(
      (max, elem) => (elem.width > max ? elem.width : max),
      this.linkContainers[0].width,
    );
    const gameId = router.currentRoute.params.id;
    if (gameId) {
      const profileWidth = this.nicknameContainer.width + this.avatarContainer.width;
      return maxLinkWidth > profileWidth ? maxLinkWidth : profileWidth;
    }

    return maxLinkWidth + this.menuWrapWidth;
  }

  /**
   * Get full height for expanded menu
   * @returns {*}
   */

  getActiveLinksCount() {
    if (this.inEducationalGames()) return this.linkContainers.length - 1;
    return this.linkContainers.length - 3;
  }

  getFullMenuHeight() {
    const linksHeight = this.linkContainerHeight * this.getActiveLinksCount();
    return linksHeight
      + this.soundIcon.displayHeight
      + this.avatarContainer.displayHeight
      + this.menuWrapHeight;
  }

  /**
   * Select link on hover
   * @param container
   */
  highlightLink(container) {
    container.each((elem) => {
      if (elem.texture.key === 'site-menu-link-frame') {
        elem.setTexture('site-menu-link-frame-light');
      } else if (elem.texture.key === 'site-menu-link-frame-left') {
        elem.setTexture('site-menu-link-frame-left-light');
      } else if (elem.texture.key === 'site-menu-link-frame-right') {
        elem.setTexture('site-menu-link-frame-right-light');
      }
    });
  }

  /**
   * Remove selection from link on mouseout
   * @param container
   */
  removeLinkHighlight(container) {
    container.each((elem) => {
      if (elem.texture.key === 'site-menu-link-frame-light') {
        elem.setTexture('site-menu-link-frame');
      } else if (elem.texture.key === 'site-menu-link-frame-left-light') {
        elem.setTexture('site-menu-link-frame-left');
      } else if (elem.texture.key === 'site-menu-link-frame-right-light') {
        elem.setTexture('site-menu-link-frame-right');
      }
    });
  }

  /**
   * Create frame with child name
   * @returns {Phaser.GameObjects.Container|null|undefined}
   */
  addName() {
    const nickname = this.activeAccount?.nickname?.trim();
    if (!nickname) return;

    const maxContainerWidth = this.maxMenuWidth - (this.avatarFrame?.displayWidth + this.menuWrapWidth);
    const container = this.add.container();
    this.nickname = this.add.text(0, -20, nickname, { font: '56px font009' });
    this.nickname.setTint(0x3ded97, 0x1eee91, 0x2ddea9, 0x2ddea9);

    if (this.nickname.width > maxContainerWidth) {
      let shortNickname = '';
      for (const letter of nickname) {
        shortNickname += letter;
        this.nickname.setText(shortNickname);
        if (this.nickname.displayWidth > maxContainerWidth) {
          shortNickname = `${shortNickname.slice(0, shortNickname.length - 2)}.`;
          this.nickname.setText(shortNickname);
          break;
        }
      }
    }

    const frameLeftCorner = this.add.sprite(0, 0, 'site-menu-name-frame-left');
    const frameNameSpace = this.add.sprite(this.nickname.displayWidth / 2, 0, 'site-menu-name-frame');
    const frameRightCorner = this.add.sprite(0, 0, 'site-menu-name-frame-right');

    const bgFrame = [
      frameLeftCorner
        .setDisplaySize(frameLeftCorner.width / 2, this.linkContainerHeight - 12)
        .setX(-(frameLeftCorner.width / 4)),
      frameNameSpace
        .setDisplaySize(this.nickname.displayWidth, this.linkContainerHeight - 12),
      frameRightCorner
        .setDisplaySize(frameRightCorner.width / 2, this.linkContainerHeight - 12)
        .setX(this.nickname.displayWidth + (frameRightCorner.width / 4)),
    ];

    const containerWidth = bgFrame.reduce((sum, currentElem) => (sum + currentElem.displayWidth), 0);
    container.add(bgFrame);
    container.add(this.nickname);
    container.setSize(containerWidth, this.linkContainerHeight);

    return container;
  }

  /**
   * Show link
   * @param link
   * @param shift
   */
  slideLink(link, shift) {
    this.tweens.add({
      targets: link,
      x: shift,
      ease: 'Power1',
      duration: this.linkAnimationDuration,
    });
  }

  slideSoundIcon(icon, shift) {
    this.tweens.add({
      targets: icon,
      y: shift,
      ease: 'Power1',
      duration: this.linkAnimationDuration,
    });
  }

  /**
   * Turn on/off sound on the site
   */
  handleSound() {
    const sound = store.getters.getSoundOn;
    store.dispatch('switchSound', !sound);
    this.switchSoundIcon();

    const game = window.activeGame;
    if (game) {
      store.getters.getSoundOn ? game.sound.setMute(false) : game.sound.setMute(true);
    }
  }

  switchSoundIcon() {
    if (this.soundIcon.texture.key === 'site-menu-sound-on-icon') {
      this.soundIcon.setTexture('site-menu-sound-off-icon');
    } else {
      this.soundIcon.setTexture('site-menu-sound-on-icon');
    }
  }

  /**
   *  Expand menu
   */
  showMenuLinks() {
    this.fullMenuWidth = this.getFullMenuWidth();
    this.fullMenuHeight = this.getFullMenuHeight();
    const menuContentWidth = this.fullMenuWidth - 60;
    this.scale.resize(this.fullMenuWidth, this.fullMenuHeight);

    this.avatarContainer.setPosition(menuContentWidth, 60);
    this.soundIcon.x = menuContentWidth;

    if (!this.showStatusAssignments) {
      this.assignmentContainer.setPosition(menuContentWidth, 255);
      this.assignmentsCounter.setPosition(menuContentWidth, 316);
      this.assignmentLinks.forEach((assignment, i) => {
        assignment.setPosition(this.fullMenuWidth, this.initialMenuHeight - 60 + this.assignmentContainer.height + 42 * i);
      });
    }


    this.tweens.add({
      targets: this.avatarContainer,
      angle: 6,
      ease: 'Sine.easeInOut',
      duration: 75,
      yoyo: true,
      repeat: 5,
    });
    // this.tweens.add({
    //   targets: [this.assignmentContainer, this.assignmentsCounter],
    //   alpha: 1,
    //   duration: this.linkAnimationDuration / 2,
    // });
    let yShift = 0;
    if (this.inEducationalGames()) {
      this.slideLink(this.nicknameContainer, this.fullMenuWidth - this.nicknameContainer.width - 40);
      this.slideLink(this.aboutLinkContainer,
        this.fullMenuWidth - this.aboutLinkContainer.width - 25);
      this.slideLink(this.restartLinkContainer,
        this.fullMenuWidth - this.restartLinkContainer.width - 25);
      this.slideLink(this.homeLinkContainer, this.fullMenuWidth - this.homeLinkContainer.width - 25);
    } else {
      this.slideLink(this.mainMenuLinkContainer,
        this.fullMenuWidth - this.mainMenuLinkContainer.width - 25);
      yShift = -20;
    }
    this.slideSoundIcon(this.soundIcon, this.fullMenuHeight - 45 + yShift);
    this.slideSoundIcon(this.assignmentContainer, this.fullMenuHeight + 45 + yShift);

    if (this.showStatusAssignments) {
      this.assignmentLinks.forEach((assignment, i) => {
        this.slideSoundIcon(assignment, this.fullMenuHeight + 45 * (i + 1) + 45 + yShift);
      });
      this.slideSoundIcon(this.exitBtn, this.fullMenuHeight + 65 + yShift);
    }

    this.slideSoundIcon(this.assignmentsCounter, this.fullMenuHeight + 105 + yShift);

    this.time.addEvent({
      callback: () => {
        this.isMenuOpen = true;
        this.canAccessSideMenu = true;
      },
      delay: this.linkAnimationDuration,
    });
  }

  /**
   * Return menu to minimized state
   */
  inEducationalGames() {
    return window.location.href.includes('game/');
  }

  hideMenuLinks() {
    this.slideLink(this.nicknameContainer, this.fullMenuWidth + this.nicknameContainer.width);

    this.slideLink(this.aboutLinkContainer, this.fullMenuWidth + this.aboutLinkContainer.width);
    this.slideLink(this.mainMenuLinkContainer, this.fullMenuWidth + this.mainMenuLinkContainer.width);
    this.slideLink(this.restartLinkContainer, this.fullMenuWidth + this.restartLinkContainer.width);
    this.slideLink(this.homeLinkContainer, this.fullMenuWidth + this.homeLinkContainer.width);
    this.slideSoundIcon(this.soundIcon, this.avatarContainer.y + 100);

    this.slideSoundIcon(this.assignmentContainer, 255);
    // this.tweens.add({
    //   targets: [this.assignmentContainer, this.assignmentsCounter],
    //   alpha: 0,10
    //   duration: this.linkAnimationDuration,
    // });
    this.slideSoundIcon(this.assignmentsCounter, 316);
    this.assignmentLinks.forEach((assignment, i) => {
      this.slideSoundIcon(assignment, 300 + (i * 40));
    });
    this.slideSoundIcon(this.exitBtn, this.fullMenuHeight - 45);

    this.isMenuOpen = false;

    this.time.addEvent({
      delay: this.linkAnimationDuration,
      callback: this.resetScale,
      callbackScope: this,
    });
  }

  /**
   *
   */
  resetScale() {
    this.scale.resize(this.initialMenuWidth, this.initialMenuHeight);
    this.avatarContainer.setPosition(this.initialMenuWidth / 2, 60);
    // this.avatarScaleTween.pause();
    this.soundIcon.setPosition(this.avatarContainer.x, this.avatarContainer.y + 100);
    this.assignmentContainer.setPosition(this.avatarContainer.x, 255);
    this.assignmentsCounter.setPosition(this.avatarContainer.x, 316);
    this.isMenuOpen = false;
    this.canAccessSideMenu = true;
  }

  /**
   *
   */
  resetAssignmentScale() {
    if (this.showStatusAssignments) return;
    this.assignmentsCounter.setPosition(this.avatarContainer.x, this.assignmentContainer.y + 60);
    this.assignmentsCounter.setAlpha(1);
  }

  /**
   *
   */
  createAssignmentWidget() {
    const frame = this.add.sprite(0, 0, 'site-menu-avatar-frame').setDisplaySize(90, 90);
    const icon = this.add.sprite(0, 0, 'site-menu-owl').setDisplaySize(45, 65);
    this.assignmentContainer = this.add.container(this.game.config.width / 2, 255, [frame, icon]);

    if (this.assignments.length === 0) this.assignmentContainer.setVisible(false);

    const containerHitArea = new Phaser.Geom.Circle(0, 0, 90);
    this.assignmentContainer.setInteractive(containerHitArea, Phaser.Geom.Circle.Contains);
  }

  /**
   *
   */
  createAssignmentCounter() {
    const frame = this.add.sprite(0, 0, 'site-menu-avatar-frame').setDisplaySize(60, 60);
    const icon = this.assignments.length <= 9 ? `site-menu-num-${this.assignments.length}` : 'site-menu-more-than-nine';
    const number = this.add.sprite(0, 0, icon).setScale(0.3);
    this.assignmentsCounter = this.add.container(this.game.config.width / 2, 316, [frame, number]);
    this.assignmentsCounter.setSize(60, 60);

    if (this.assignments.length === 0) this.assignmentsCounter.setVisible(false);
  }

  /**
   *
   * @param assignment
   * @param i
   * @returns {*}
   */
  createAssignmentLink(assignment, i) {
    // eslint-disable-next-line no-underscore-dangle
    const isCurrent = this.currentAssignment && assignment._id === this.currentAssignment._id;
    // const isCurrent = true;
    const width = 340;
    const height = 36;
    const container = this.add.container(width, height);

    const bg = this.add.graphics();
    bg.fillStyle(0xffffff, 1);
    bg.fillRoundedRect(0, 0, width, height, 18);

    // eslint-disable-next-line no-unused-expressions
    isCurrent ? bg.lineStyle(3, 0xff0000, 3) : bg.lineStyle(1, 0x3dd1ff, 1);
    bg.strokeRoundedRect(2, 2, width - 4, height - 4, 16);

    bg.fillStyle(0xededed, 1);
    bg.fillRoundedRect(3, 3, 40, height - 6, {
      tl: 16, tr: 0, bl: 16, br: 0,
    });

    const number = this.add.text(20, 6, i + 1, { font: '20px Arial', fill: '#000000', align: 'center' });
    const name = this.add.text((width - 4) / 4, 6, assignment.name, {
      font: '20px Arial',
      fill: '#000000',
      align: 'center',
    });
    // const date = this.add.text(10, 10, moment(assignment.dueDate).format('MMM d'), {
    //   font: '20px Arial',
    //   fill: '#000000',
    //   align: 'center',
    // });

    container.add(bg);
    container.add(name);
    // container.add(date);
    container.add(number);
    container.setPosition(width, this.initialMenuHeight - 60 + this.assignmentContainer.height + 42 * i);
    container.setSize(width, height);

    const containerHitArea = new Phaser.Geom.Rectangle(width / 2, 0, width, height);
    container.setInteractive(containerHitArea, Phaser.Geom.Rectangle.Contains);

    this.assignmentLinks.push(container);

    return container;
  }

  /**
   *
   */
  showAssignments() {
    if (this.assignmentLinks.length === 0) return;
    this.fullMenuWidth = this.isMenuOpen ? this.fullMenuWidth : this.assignmentLinks[0].width + 60;
    const widgetHeight = this.assignmentLinks.length * this.assignmentLinks[0].height + 20;
    this.fullMenuHeight = this.isMenuOpen
      ? this.fullMenuHeight + widgetHeight + 160
      : this.initialMenuHeight + widgetHeight;
    this.scale.resize(this.fullMenuWidth, this.fullMenuHeight);

    this.avatarContainer.setPosition(this.fullMenuWidth - 60, 60);
    this.soundIcon.x = this.fullMenuWidth - 60;

    this.assignmentContainer.setPosition(this.fullMenuWidth, this.assignmentContainer.y);
    this.exitBtn.setAlpha(1);
    this.showStatusAssignments = true;
    this.exitBtn.setPosition(this.fullMenuWidth - 40, this.assignmentContainer.y + 20);
    this.assignmentsCounter.setAlpha(0);

    const shift = this.fullMenuWidth - this.assignmentLinks[0].width;
    this.slideLink(this.assignmentContainer, shift + 24);

    this.assignmentLinks.forEach((assignment, i) => {
      assignment.y = this.assignmentContainer.y + 45 + 42 * i;
      this.slideLink(assignment, shift - 20);
    });
  }

  /**
   *
   */
  hideAssignments() {
    this.assignmentLinks.forEach((assignment) => {
      this.slideLink(assignment, assignment.x + assignment.width + 20);
    });
    this.showStatusAssignments = false;
    const shift = this.fullMenuWidth - 60;
    this.slideLink(this.assignmentContainer, shift);
    this.exitBtn.setAlpha(0);

    this.time.addEvent({
      delay: this.linkAnimationDuration - 100,
      callback: this.resetAssignmentScale,
      callbackScope: this,
    });
  }

  /**
   *
   * @param assignmentId
   */
  goToAssignment(assignmentId) {
    router.push({ name: 'profile-assignment', params: { assignmentId } });
    this.hideAssignments();
  }
}

EDC.UI.SiteMenu = SiteMenuMainScene;

export default SiteMenuMainScene;
